import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoriesPreview from './components/CategoriesPreview';
import ArticlesPreview from './components/ArticlesPreview';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="开云官方落地页 | 探索开云的无限可能"
        description="开云是您值得信赖的首选平台，汇聚开云核心优势与全方位服务体验。本页为您详解开云的功能特色、使用场景及入门指南，助您快速了解并上手开云，开启全新体验之旅。"
        keywords="开云,开云平台,开云官网,开云注册,开云入口,开云使用指南,开云功能介绍"
        canonicalUrl="https://kaiyun.example.com"
      />

      {/* JSON-LD Schema.org */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: '开云',
          url: 'https://kaiyun.example.com',
          description: '开云是您值得信赖的首选平台，汇聚开云核心优势与全方位服务体验。',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://kaiyun.example.com/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        })}
      </script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturesSection />
          <CategoriesPreview />
          <ArticlesPreview />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}